import {
  DashboardRoutes,
  CRMRoutes,
  CommercialRoutes,
  PurchseRoutes,
  ProductionRoutes,
  AdminRoutes,
  AuditreportsRoutes,
  FinanceRoutes,
} from './routes';
import { commonStrings, breadcrumbStrings, productionScheduleStrings } from '../components/StringBundle';
import type { RouteItem, ModuleConfigEntry } from '../screens/admin/types';

export const MODULE_CONFIG: ModuleConfigEntry[] = [
  { moduleLabel: breadcrumbStrings.modules.dashboard, routes: DashboardRoutes as RouteItem[] },
  { moduleLabel: breadcrumbStrings.modules.crm, routes: CRMRoutes as RouteItem[] },
  { moduleLabel: breadcrumbStrings.modules.commercial, routes: CommercialRoutes as RouteItem[] },
  { moduleLabel: breadcrumbStrings.modules.purchase, routes: PurchseRoutes as RouteItem[] },
  { moduleLabel: breadcrumbStrings.modules.production, routes: ProductionRoutes as RouteItem[] },
  { moduleLabel: breadcrumbStrings.modules.finance, routes: FinanceRoutes as RouteItem[] },
  { moduleLabel: breadcrumbStrings.modules.admin, routes: AdminRoutes as RouteItem[] },
  { moduleLabel: breadcrumbStrings.modules.auditReports, routes: AuditreportsRoutes as RouteItem[] },
];

export const MODULE_DEPT_KEYS: Record<string, string> = {
  [breadcrumbStrings.modules.dashboard]: 'dashboard',
  [breadcrumbStrings.modules.crm]: 'crm',
  [breadcrumbStrings.modules.commercial]: 'commercial',
  [breadcrumbStrings.modules.purchase]: 'purchase',
  [breadcrumbStrings.modules.production]: 'pq',
  [breadcrumbStrings.modules.finance]: 'finance',
  [breadcrumbStrings.modules.admin]: 'admin',
  [breadcrumbStrings.modules.auditReports]: 'audit',
};

export const PARENT_PATH_OVERRIDES: Record<string, string> = {
  '/quotation-item': '/quotation',   // sub-resource of quotation
  '/dispatch': '/dispatchinfo', // new dispatch CRUD routes — list lives at /dispatchinfo
};

export const TAB_LABEL_MAP: Record<string, string | null> = {
  details: null,
  activity: commonStrings.auditLog,
  auditlog: commonStrings.auditLog,
  notes: commonStrings.notes,
  attachments: commonStrings.attachment,
  workorderinformation: breadcrumbStrings.tabs.workOrderInformation,
  blendsheetInformation: breadcrumbStrings.tabs.blendSheetInformation,
  orderdispatch: breadcrumbStrings.tabs.orderDispatch,
  orderdispatches: breadcrumbStrings.tabs.orderDispatches,
  orderlineitem: breadcrumbStrings.tabs.orderLineItem,
  orderlineitems: breadcrumbStrings.tabs.orderLineItems,
  quotationdetails: breadcrumbStrings.tabs.quotationDetails,
  salesorderinformation: breadcrumbStrings.tabs.salesOrderInformation,
  softschedules: breadcrumbStrings.tabs.softSchedules,
  samplelineiteminformation: breadcrumbStrings.tabs.sampleLineItemInformation,
  allocation: breadcrumbStrings.tabs.allocationInformation,
  mrin: breadcrumbStrings.tabs.mrin,
  preShipmentSample: breadcrumbStrings.tabs.preShipmentSample,
  order: breadcrumbStrings.tabs.orders,
};

export const PAGE_LABEL_OVERRIDES: Record<string, string> = {
  // CRM
  '/sample-request': breadcrumbStrings.pages.sampleRequests,
  '/quotation': breadcrumbStrings.pages.quotations,
  // Commercial
  '/order': breadcrumbStrings.pages.orders,
  '/orderlineitem': breadcrumbStrings.pages.orderLineItems,
  '/orderdispatch': breadcrumbStrings.pages.orderDispatches,
  '/soft-scheduling': breadcrumbStrings.pages.softSchedules,
  '/production-schedule': breadcrumbStrings.pages.productionSchedules,
  // Purchase
  '/supplier': breadcrumbStrings.pages.suppliers,
  '/packing-type': breadcrumbStrings.pages.packingTypes,
  '/blend-sheet': breadcrumbStrings.pages.blendSheets,
  // Production
  '/certification': breadcrumbStrings.pages.certifications,
  '/batch-Output': breadcrumbStrings.pages.batchOutputs,
  '/forecast-capacity': breadcrumbStrings.pages.forecastCapacity,
};

export const DIRECT_LABEL_OVERRIDES: Record<string, string> = {
  'calendar-blocking': productionScheduleStrings.forms.calendar,
  'contract-reports': productionScheduleStrings.forms.contractReports,
};

export const VIEW_TAB_EXCEPTIONS: Record<string, ReadonlySet<string>> = {
  '/contacts':          new Set(['billing', 'shipping']),
  '/orderdispatch':     new Set(['salesorderinformation']),
  '/soft-scheduling':   new Set(['soft-schedule']),
  '/order':             new Set(['order']),
};
